import { Component, h, Element, Host, Prop, State } from '@stencil/core';
import W3Tabs from './libraries/w3_tabs';
import { ResponsiveString } from '../../typings';
import { WindowResizeService } from '../../services/window-resize-service';

/**
 * @slot content - This slot will usually serve specific markup to ensure tabs are accessible.
 * @slot - Default slot, same as content slot.
 */
@Component({
  tag: 'content-tabs',
  styleUrl: 'content-tabs.scss',
  shadow: false,
})
export class ContentTabs {
  @Element() private element: HTMLElement;
  /**
   * @type String
   * @responsive
   */
  @Prop({
    mutable: true,
    reflect: true,
  })
  classes: ResponsiveString;

  @State() classString: string;

  componentWillLoad() {
    WindowResizeService.registerProp(this.classes).subscribe(newValue => {
      this.classString = newValue as string;
    });
  }

  componentDidLoad() {
    new W3Tabs(this.element);
  }
  render() {
    return (
      <Host class={this.classString}>
        <slot name="content"></slot>
        <slot></slot>
      </Host>
    );
  }
}
